var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26176 10.224C6.87654 10.2421 5.52223 10.6546 4.34432 11.4171C3.16641 12.1797 2.20944 13.2635 1.57622 14.5521C0.942999 15.8407 0.657463 17.2853 0.750293 18.7309C0.843109 20.1762 1.31068 21.5678 2.10278 22.7561C2.80475 23.8115 3.73944 24.6741 4.82917 25.2691C5.9189 25.8641 7.13015 26.1744 8.35945 26.1734H25.0431C26.1619 26.1739 27.2599 25.8575 28.2205 25.2578C29.1811 24.6581 29.9686 23.7976 30.4992 22.7676C30.9909 21.813 31.2453 20.7443 31.2399 19.6599C31.2345 18.5756 30.969 17.51 30.4678 16.5607C29.9665 15.6115 29.2455 14.809 28.3708 14.2267C27.4961 13.6444 26.4957 13.301 25.4612 13.2278C25.0025 11.3567 24.0327 9.66513 22.6721 8.35886C21.3115 7.05256 19.6173 6.18774 17.7954 5.86954C15.9736 5.55135 14.1026 5.79347 12.4099 6.56647C10.7172 7.33948 9.27693 8.61021 8.26176 10.224ZM22.5868 13.7423C23.3304 13.406 24.1296 13.2262 24.9388 13.2127C24.1289 13.2256 23.3289 13.4051 22.5846 13.7414L7.74886 20.271L22.5868 13.7423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDrive);
export default __webpack_public_path__ + "static/media/one-drive.035d93717fd1ee99052ac1585b0cf30a.svg";
export { ForwardRef as ReactComponent };